<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "form_fields_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-with-0-margin">
        <sp-form-element-settings-signal
            [element]="element()"
            [elements]="elements()"
            [selectedChatBots]="chatBots()"
            [addChatBotToForm]="addChatBotToForm()"
            [addressBookVariablesList]="addressBookVariablesList()"
            [crmContactsVariablesList]="crmContactsVariablesList()"
            [crmDealsVariablesList]="crmDealsVariablesList()"
            [isAddressBookListDisabled]="isAddressBookListDisabled()"
            [baseHref]="baseHref"
            [deviceMode]="selectedDeviceMode$ | async"
            [variablesOptions]="variablesOptions()"
            [isInitVariables]="isInitVariables()"
            (valueChangeEvent)="onElementChange($event)"
            (chatBotVariableChange)="onChatBotVariableChange($event)"
        />
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
